import { object, string } from 'yup';
import { useStyles } from './style';

import { Button, Typography } from '@forgeglobal/design-framework';
import Form, {
  Field,
  FieldRenderProps,
  FormRenderProps,
} from '@tcs/common/components/atoms/Form';
import TextField from '@tcs/common/components/atoms/TextField';

interface SecurityQueryFormProps {
  onSubmit: (value: { answer: string }) => void;
  onCancel: () => void;
  question: string;
}

const SecurityQuestionsForm = ({
  onSubmit,
  onCancel,
  question,
}: SecurityQueryFormProps) => {
  const classes = useStyles();

  const validationSchema = object({
    answer: string().required('Please enter your answer'),
  });

  return (
    <Form
      onSubmit={onSubmit}
      validationSchema={validationSchema}
      render={({ handleSubmit, submitting }: FormRenderProps) => (
        <form onSubmit={handleSubmit}>
          <div className={classes.fields}>
            <div
              className={classes.questionLabelContainer}
              data-test-id="question-field">
              <Typography
                data-test-id="question-label"
                className={classes.questionLabel}
                color="textSecondary"
                component="label">
                Question
              </Typography>
              <Typography
                data-test-id="question-text"
                variant="body2"
                color="textPrimary"
                component="p">
                {question}
              </Typography>
            </div>
            <Field
              data-test-id="answer-field"
              name="answer"
              render={(props: FieldRenderProps<string>) => (
                <TextField label="Answer" data-private {...props} />
              )}
            />
          </div>

          <div className={classes.buttons}>
            <Button
              size="medium"
              color="secondary"
              onClick={onCancel}
              data-test-id="previous-button">
              Previous
            </Button>
            <Button
              size="medium"
              color="primary"
              type="submit"
              disabled={submitting}
              className={classes.primaryButton}
              data-test-id="submit-button">
              Submit
            </Button>
          </div>
        </form>
      )}
    />
  );
};

export default SecurityQuestionsForm;
